export default "__VITE_ASSET__Droc6ZQ8__"